import React from 'react';

const SolPolitics = () => {
  return <h1>SolPolitics Page</h1>;
};

export default SolPolitics;
